/* eslint-disable no-restricted-syntax */
/* eslint-disable no-plusplus */
/* eslint-disable arrow-body-style */
import { CallLeg } from "../C2GReport";
import { CXAgent } from "../CxDashboard";

export interface CxCallEvent {
    id: string;
    event: string;
    timeStamp: string;
    type: string;
    username?: string;
    portrait?: string;
    queueName?: string;
    recordingUrl?: string;
  }
  
  export interface CallEvent {
    ownerId?: string;
    index?: string;
    body: {
      eventTime: string;
      telephonySessionId: string;
      origin: {
        type: string;
      };
      sequence?: number;
      parties: [
        {
          isUser: any;
          id: string;
          extensionId: string;
          direction: string;
          missedCall?: boolean;
          ivr?: string;
          accountId?: string;
  
          status: {
            code: string;
            reason?: string;
            message?: string;
          };
          from?: {
            phoneNumber: string;
            name?: string;
            extensionNumber: string;
            extensionId?: string;
          };
          to?: {
            phoneNumber: string;
            name?: string;
            extensionNumber: string;
            extensionId?: string;
          };
          queueCall?: boolean;
          queue?: string;
          user?: string;
        }
      ];
    };
  }

// data parsing functions
export function FormatEXCallEvents(callUsers: any) {
    const allEvents = callUsers
      .reduce((events: Array<any>, user: any) => events.concat(user.events), [])
      .sort((a: any, b: any) => {
        if (a.body.eventTime < b.body.eventTime) {
          return -1;
        }
        if (a.body.eventTime > b.body.eventTime) {
          return 1;
        }
        return 0;
      });

    const callHistory = [] as CallLeg[];
    allEvents.forEach((event: any) => {
      const { direction } = event.body.parties[0];
      const fromExt = event.body.parties[0].from.extensionId;
      const fromPhone = event.body.parties[0].from.phoneNumber;
      const fromName = event.body.parties[0].from.name;
      const toExt = event.body.parties[0].to.extensionId;
      const toPhone = event.body.parties[0].to.phoneNumber;
      const toName = event.body.parties[0].to.name;
      const status = event.body.parties[0].status.code;
      const { eventTime } = event.body;
      let state;
      if (status === "Setup") {
        state = "Setup";
      } else if (status === "Proceeding") {
        state = "Ringing";
      } else if (direction === "Outbound" && status === "Answered") {
        state = "Connected/Answered";
      } else if (direction === "Inbound" && status === "Answered") {
        state = "Answered";
      } else if (status === "Voicemail") {
        state = "Forwarded to voicemail";
      } else if (status === "FaxReceive") {
        state = "Fax receiving started";
      } else if (status === "Hold") {
        state = "Put on hold";
      } else if (status === "VMScreening") {
        state = "Listening to voicemail";
      } else {
        state = status;
      }
      callHistory.push({
        id: event.uuid,
        eventTime: new Date(eventTime).toLocaleString("en-CA"),
        direction,
        state,
        fromExt,
        fromPhone,
        fromName,
        toExt,
        toPhone,
        toName,
        status,
      });
    });
    return allEvents;
}

export function FormatCXCallEvents(
  callData: any, 
  cxAgents: CXAgent[],
  ) {
    const rawCxEventArray: any[] = [];
    const cxDataMap: Map<string, CxCallEvent[]> = new Map();
    const redundantEvents: number[] = [];
    for (const k in callData) {
      if (k.includes("#")) {
        const [id, property] = k.split("#");
        const exUser = cxAgents?.find((user: any) => user.agentId === id)
        rawCxEventArray.push({
          id,
          event: property,
          timeStamp: callData[k],
          type: callData?.[id]?.extension || "",
          queueName: callData[id]?.queueName || undefined,
          username: callData[id]?.agentFirstName && callData[id]?.agentLastName ? (`${callData[id]?.agentFirstName} ${callData[id]?.agentLastName}`) : undefined,
          recordingUrl: callData[id]?.recordingUrl,
          portrait: exUser?.portrait
        });
      }
    }
    rawCxEventArray
    .sort((eventA, eventB) => {
      const firstDate = new Date(eventA.timeStamp).getTime() 
      const lastDate = new Date(eventB.timeStamp).getTime() 
      if (firstDate === lastDate) {
        if (eventA.event.includes('abandonTime')) {
          return -1;
        }
        if (eventA.event.includes('connectedTime')) {
          return 1;
        }
      }
      if (firstDate < lastDate) {
        return -1
      }
      return 1
    })
    .forEach((cxEvent, i, arr) => {
        const { id, event, type, timeStamp } = cxEvent;
        const rawCallDataEvent = callData[id];
        const exUser = cxAgents?.find((user: any) => user.agentId === id)
        if (type === "queue") {
          const hasAConnectEvent = arr.find((callEvent) => callEvent.event === 'connectedTime') 
          // if theres been a connected event, we assume a queue disconnect
          if (hasAConnectEvent && hasAConnectEvent !== undefined) {
            rawCxEventArray.push({
              id,
              event: 'disconnectedTime',
              timeStamp: hasAConnectEvent.timeStamp,
              type: 'queue',
              queueName: rawCallDataEvent.queueName || undefined,
              username: undefined,
              portrait: exUser?.portrait,
              recordingUrl: rawCallDataEvent.recordingUrl,

            })
          }
          // if there is no connected event, we'll build it using the abandonTime value + duration 
          if (!hasAConnectEvent || hasAConnectEvent === undefined) {
            rawCxEventArray.push({
              id,
              event: 'disconnectedTime',
              timeStamp: new Date(
                new Date(timeStamp)?.getTime() + ((Number(callData[id]?.duration || callData?.callEnd?.call_duration) * 1000))
                )?.toISOString(),
              type: 'queue',
              queueName: rawCallDataEvent.queueName || undefined,
              username: undefined,
              recordingUrl: rawCallDataEvent.recordingUrl,
              portrait: exUser?.portrait,
            })
          }
          
        }

        if (type === 'agent') {
          // if there's no disconnected value for an agent, take the call duration time. ensure the call event doesnt have a no Answer event.
          const hasAConnectEvent = arr.find((callEvent) => callEvent.event === 'connectedTime') 
          const hasANoAnswerEvent = arr.find((callEvent) => callEvent.id === id && callEvent.event === 'noAnswerTime')
          if (event === 'deflectedTime' && callData.callEnd?.recording_url !== undefined && callData.callEnd?.recording_url !== null) {
            rawCxEventArray.push({
              id,
              event: 'leftVoicemail',
              timeStamp,
              type: 'agent',
              queueName: undefined,
              username: rawCallDataEvent?.agentFirstName && rawCallDataEvent?.agentLastName ? (`${rawCallDataEvent?.agentFirstName} ${rawCallDataEvent?.agentLastName}`) : undefined,
              recordingUrl: rawCallDataEvent?.recordingUrl,
              portrait: exUser?.portrait,
            })
          }
          if ((!hasAConnectEvent || hasAConnectEvent === undefined) && !hasANoAnswerEvent) {
            rawCxEventArray.push({
              id,
              event: 'disconnectedTime',
              timeStamp: arr.find((callEvent) => callEvent.event === 'disconnectedTime')?.timeStamp,
              type: 'agent',
              queueName: undefined,
              username: rawCallDataEvent?.agentFirstName && rawCallDataEvent?.agentLastName ? (`${rawCallDataEvent?.agentFirstName} ${rawCallDataEvent?.agentLastName}`) : undefined,
              recordingUrl: rawCallDataEvent?.recordingUrl,
              portrait: exUser?.portrait,
            })
          }
        }
        if (event === 'connectedTime' && arr.find((e) => e.event === 'accurate-connectedTime' && e.id === id )) {
          redundantEvents.push(i)
        }
        if (event === 'disconnectedTime' && arr.find((e) => e.event === 'accurate-disconnectedTime' && e.id === id )) {
          redundantEvents.push(i)
        }
        if (event === 'abandonTime' && arr.find((e) => e.event === 'accurate-abandonTime' && e.id === id )) {
          redundantEvents.push(i)
        }
      })    
    redundantEvents.forEach((i) => {
      rawCxEventArray.splice(i,1)
    })
    rawCxEventArray.forEach((event) => {
      if (!cxDataMap.has(event.id)) {
        cxDataMap.set(event.id, []);
      }
      if (cxDataMap.has(event.id)) {
        cxDataMap?.get(event.id)?.push(event);
      }
    })
    return cxDataMap;
}

// UI functions
export const reasonRenderer = (reason: string | undefined) => { 
  if (reason === 'abandonTime') {
    return 'Ringing'
  }
  if (reason === 'noAnswerTime') {
    return 'Disconnected (No Answer)'
  }
  if (reason === 'connectedTime' || reason === 'accurate-connectedTime') {
    return 'Connected'
  }
  if (reason === 'disconnectedTime') {
    return 'Disconnected'
  }
  if (reason?.includes('transfer-')) {
    return `Call transferred ${reason.split("-")[1] && `(${reason.split("-")[1].split("Time")[0]})` }`
  }
  return reason;
} 